import { render, staticRenderFns } from "./MailboxThread.vue?vue&type=template&id=d33d09dc&scoped=true"
import script from "./MailboxThread.vue?vue&type=script&lang=js"
export * from "./MailboxThread.vue?vue&type=script&lang=js"
import style0 from "./MailboxThread.vue?vue&type=style&index=0&id=d33d09dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33d09dc",
  null
  
)

export default component.exports